import { createI18n } from "vue-i18n";
// For datepicker language
import { Settings } from "luxon";

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });

  return messages;
}

let defaultLang = window.navigator.language
  ? window.navigator.language.split("-")[0]
  : "en";

// Desteklenen diller (locales klasöründeki dosyalar)
const availableLocales = [
  "en",
  "tr",
  "es",
  "fr",
  "de",
  "it",
  "pt",
  "ru",
  "ja",
  "zh",
  "ar",
  "th",
];

// URL'den locale parametresini oku
try {
  const urlParams = new URLSearchParams(window.location.search);
  const paramLocale = urlParams.get("locale") || urlParams.get("lang");

  if (paramLocale && availableLocales.includes(paramLocale)) {
    defaultLang = paramLocale;
    // localStorage'a kaydet
    localStorage.setItem("locale", paramLocale);
  } else {
    // URL'de parametre yoksa localStorage'dan oku
    const savedLocale = localStorage.getItem("locale");
    if (savedLocale && availableLocales.includes(savedLocale)) {
      defaultLang = savedLocale;
    }
  }
} catch (e) {
  console.warn("URL/localStorage locale error:", e);
}

// Eğer seçilen dil mevcut değilse, en'e fallback yap
if (!availableLocales.includes(defaultLang)) {
  defaultLang = "en";
}

// For datepicker language
Settings.defaultLocale = defaultLang;
document.documentElement.setAttribute("lang", defaultLang);

const i18n = new createI18n({
  locale: defaultLang,
  fallbackLocale: "en",
  messages: loadLocaleMessages(),
});

export default i18n;
